'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _video = require('video.js');

var _video2 = _interopRequireDefault(_video);

var _ComponentEventProcessorBase = require('./ComponentEventProcessorBase');

var _ComponentEventProcessorBase2 = _interopRequireDefault(_ComponentEventProcessorBase);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Creates an InBandEventProcessor Plugin to process
 * captured inband live stream events.  
 * This plugin leverages video.js's emulated text tracks looking
 * for a metadata track and monitoring cue changes to capture inband
 * event data.
 *
 * @param {Player} player
 *        A Video.js player instance.
 * 
 * @param {Object} options 
 *        The options to configure the plugin.
 * 
 *        Options object should include:
 * 
 *        @param {Function} dataHandler
 *        Data handler when the plugin fires `inBandEvent`.
 * 
 *        @param {Function} trackHandler
 *        Event handler to process a newly added track.
 * 
 */
var InBandEventProcessor = function (_ComponentEventProces) {
  _inherits(InBandEventProcessor, _ComponentEventProces);

  function InBandEventProcessor(player, options) {
    _classCallCheck(this, InBandEventProcessor);

    return _possibleConstructorReturn(this, (InBandEventProcessor.__proto__ || Object.getPrototypeOf(InBandEventProcessor)).call(this, player, options));
  }

  /**
   * Subscribe to the `inBandEvent` and invoke the dataHandler that's
   * passed in via options.  Forward the inBandEvent data to the dataHandler.
   */


  _createClass(InBandEventProcessor, [{
    key: 'addEventListeners',
    value: function addEventListeners() {
      var _this2 = this;

      this.on(_constants.VideoEvents.COMPONENT_EVENT, function (event, data) {
        _this2.dataHandler(event, data);
      });
    }
  }]);

  return InBandEventProcessor;
}(_ComponentEventProcessorBase2.default);

exports.default = InBandEventProcessor;


_video2.default.registerPlugin('inBandEventProcessor', InBandEventProcessor);